import React from "react";
import PropTypes from "prop-types";
import { Table, Icon } from "semantic-ui-react";
import _ from "lodash";
import shortid from "shortid";
import ModalComentarios from "../../../pages/shared/ModalComentarios";

class TablaCobros extends React.Component {
  state = {
    column: "alumnoNombre",
    data: this.props.datos,
    direction: "ascending"
  };

  componentWillReceiveProps(nextProps, nextContext) {
    this.setState({
      data: _.sortBy(nextProps.datos, "alumnoNombre")
    });
  }

  handleSort = clickedColumn => () => {
    const { column, data, direction } = this.state;

    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        data: _.sortBy(data, [clickedColumn]),
        direction: "ascending"
      });

      return;
    }

    this.setState({
      data: data.reverse(),
      direction: direction === "ascending" ? "descending" : "ascending"
    });
  };

  render() {
    const { column, data, direction } = this.state;
    return (
      <Table sortable celled compact>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell
              sorted={column === "estado" ? direction : null}
              onClick={this.handleSort("estado")}
            >
              Estado
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={column === "alumnoNombre" ? direction : null}
              onClick={this.handleSort("alumnoNombre")}
            >
              Nombre Alumno
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={column === "alumnoApellidos" ? direction : null}
              onClick={this.handleSort("alumnoApellidos")}
            >
              Apellidos Alumno
            </Table.HeaderCell>
            <Table.HeaderCell>
              <Icon name="mail outline" />
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={column === "colegio" ? direction : null}
              onClick={this.handleSort("colegio")}
            >
              Colegio
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={column === "concepto" ? direction : null}
              onClick={this.handleSort("concepto")}
            >
              Actividad
            </Table.HeaderCell>
            <Table.HeaderCell
              collapsing
              sorted={column === "importeFinal" ? direction : null}
              onClick={this.handleSort("importeFinal")}
            >
              Importe Total
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={column === "iban" ? direction : null}
              onClick={this.handleSort("iban")}
            >
              IBAN
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {_.map(data, d => (
            <Table.Row
              key={shortid.generate()}
              className={
                d.baja && !d.alta ? "red" : !d.baja && d.alta ? "green" : ""
              }
            >
              <Table.Cell>
                {d.baja && <Icon color="red" name="minus" />}
                {d.alta && <Icon color="green" name="add" />}
                {d.estado}
              </Table.Cell>
              <Table.Cell>
                {d.baja && <Icon color="red" name="minus" />}
                {d.alta && <Icon color="green" name="add" />}
                {d.alumnoNombre}
              </Table.Cell>
              <Table.Cell>
                {d.baja && <Icon color="red" name="minus" />}
                {d.alta && <Icon color="green" name="add" />}
                {d.alumnoApellidos}
              </Table.Cell>
              <Table.Cell>
                <ModalComentarios
                  headerText={`Comentarios de ${d.alumnoNombre} ${
                    d.alumnoApellidos
                  } `}
                  color="yellow"
                  content={d.comentarios || null}
                  itemID={d.idAlumno}
                  onSave={this.props.action}
                  icon={d.comentarios ? "mail" : "mail outline"}
                />
              </Table.Cell>
              <Table.Cell>
                {d.baja && <Icon color="red" name="minus" />}
                {d.alta && <Icon color="green" name="add" />}
                {d.colegio}
              </Table.Cell>
              <Table.Cell>
                {d.baja && <Icon color="red" name="minus" />}
                {d.alta && <Icon color="green" name="add" />}
                {d.concepto}
              </Table.Cell>
              <Table.Cell>
                {d.baja && <Icon color="red" name="minus" />}
                {d.alta && <Icon color="green" name="add" />}
                {` ${d.importeFinal} € `}
              </Table.Cell>
              <Table.Cell>
                {d.baja && <Icon color="red" name="minus" />}
                {d.alta && <Icon color="green" name="add" />}
                {d.iban}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    );
  }
}

TablaCobros.propTypes = {
  datos: PropTypes.array.isRequired
};

export default TablaCobros;



// WEBPACK FOOTER //
// ./src/pages/listados/listadoCobros/TablaCobros.jsx